module.exports = __webpack_public_path__ + "img/Logo-27.8df786cd.svg";